<template>
  <section class="introduction">
    <div class="introduction__inner">
      <div class="introduction__text">
        <span class="introduction__greeting"
          ><em>Hi, I'm Michal.</em> Nice to meet you.</span
        >
        <p class="introduction__description">
          I am a full stack web developer. I have been around the web
          technologies since 2004. I am an information technologies university
          graduate. My experience spans from UX/UI design to both
          <strong>backend</strong> and <strong>frontend</strong> development. I
          deliver projects on time with exceptional quality. I live and work
          from Brno, Czech republic <strong>(GMT+2)</strong>. I usually engage
          in <strong>remote</strong> based collaborations.
        </p>
      </div>
      <div class="sitting_person">
        <img :src="sittingPersonSvgSrc" alt="Guy with a laptop" width="227" />
      </div>
    </div>
  </section>
</template>

<script>
import sittingPersonSvgSrc from "../assets/sitting_person.svg";

export default {
  name: "Introduction",
  data: () => ({
    sittingPersonSvgSrc
  })
};
</script>

<style scoped lang="scss">
@import "../styles/_variables";

.introduction {
  filter: drop-shadow(1px 1px 5px rgba(89, 121, 44, 0.26));
}

.introduction__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 35px calc(20px + 3vw);

  text-align: center;

  background: linear-gradient(159deg, #f0ff00, #58cffb);

  @media (min-width: $sm-up) {
    flex-direction: row;
    padding: 35px calc(79px + 3vw);

    text-align: left;

    clip-path: polygon(0 0, 100% 0, calc(100% - 33px) 100%, calc(37px) 100%);
  }

  .introduction__text {
    order: 1;
    margin-top: $spacing4;

    @media (min-width: $sm-up) {
      order: 0;
      margin-top: 0;
    }

    & > .introduction__greeting {
      font-family: $font-alt;
      font-size: 1.875rem;
      color: #fff;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
      letter-spacing: 0.05em;

      & > em {
        font-style: normal;
        color: #4e9f1c;
        text-shadow: none;
      }
    }

    & > .introduction__description {
      color: #fff;
      font-style: italic;
      font-weight: 300;
      letter-spacing: 0.05em;
      text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.05);
    }
  }

  .sitting_person {
    padding-left: 0;
    order: 0;

    @media (min-width: $sm-up) {
      padding-left: calc(20px + 3vw);
      order: 1;
    }
  }
}
</style>
